export default __webpack_public_path__ + "static/media/j.2c0180f1.svg";